var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mf-container"},[_vm._l((_vm.files),function(f){return _vm._t("file",function(){return [_c('a',{key:f.id,attrs:{"href":f.url,"target":"_blank"}},[_vm._v(" "+_vm._s(f.name)+" "),(_vm.showSize)?_c('span',[_vm._v("("+_vm._s(_vm.formatBytes(f.size))+")")]):_vm._e()])]},{"file":f})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }